import { Getters } from 'vuex-smart-module';
import ReportsSalesState from './state';

export default class ReportsSalesGetters extends Getters<ReportsSalesState> {}
